import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  city: string;
  quote: string;
  rating: number;
}
export function TestimonialsSection() {
  const testimonials: Testimonial[] = [{
    name: 'Martín González',
    age: 28,
    city: 'Buenos Aires',
    quote: 'Pasé de improvisar cada sesión a tener todo organizado. Ahora atiendo 30% más pacientes sin sentirme agotado.',
    rating: 5
  }, {
    name: 'Lucía Fernández',
    age: 32,
    city: 'Córdoba',
    quote: 'El sistema me dio la claridad que necesitaba. Ya no dudo en cada paciente, simplemente ejecuto el protocolo.',
    rating: 5
  }, {
    name: 'Santiago Rodríguez',
    age: 26,
    city: 'Rosario',
    quote: 'Recién recibido y este sistema me salvó. Tengo la estructura que no me dieron en la facultad.',
    rating: 5
  }, {
    name: 'Carolina Méndez',
    age: 35,
    city: 'Mendoza',
    quote: 'Llevo 8 años atendiendo y siempre sentí que me faltaba algo. Esto conectó todo lo que sabía de forma práctica.',
    rating: 5
  }, {
    name: 'Diego Morales',
    age: 29,
    city: 'Tucumán',
    quote: 'Dejé de perder tiempo pensando qué hacer. Ahora entro al consultorio con total seguridad y mis pacientes lo notan.',
    rating: 5
  }];
  return <section className="w-full px-4 py-20 bg-gradient-to-b from-[#0f172a] to-[#1e293b]" data-id="element-133">
      <div className="max-w-6xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-135">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-136">
            LO QUE DICEN QUIENES YA LO USAN
          </h2>
          <p className="text-xl text-gray-400" data-id="element-137">
            Kinesiólogos que transformaron su práctica
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-138">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1 * index
        }} className="bg-[#1e293b] border border-gray-700 p-6 rounded-xl hover:border-yellow-400/50 transition-colors" data-id="element-139">
              <div className="flex items-center gap-1 mb-4" data-id="element-140">
                {Array.from({
              length: testimonial.rating
            }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-141" />)}
              </div>

              <QuoteIcon className="w-8 h-8 text-yellow-400/30 mb-3" data-id="element-142" />

              <p className="text-gray-300 mb-6 italic leading-relaxed" data-id="element-143">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-gray-800 pt-4" data-id="element-144">
                <p className="font-bold text-white" data-id="element-145">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-146">
                  {testimonial.age} años • {testimonial.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}